// extracted by mini-css-extract-plugin
export default {"leftModal":"LeftModal_leftModal__m43Fa"};